module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_train--light-blue-0e379783796d23e78421b6a8d133753c.svg";